window.onload = function() {

  var app = new Vue({
    el: '#app',
    delimiters: ['!{', '}'],
    data: {
      isLensReplacement: isLensReplacement,
      showForm: false,
      framesOnly: !isLensReplacement,
      prescriptionType: '',
      lensType: '',
      lensesType: '',
      tintType: '',
      tintColor: '',
      lightAdjustingType: '',
      thickness: '29921529987171',
      provideOption: '',
      dualPd: '',
      prismValues: '',
      odrightsphere: '',
      osleftsphere: '',
      osleftcylinder: '',
      odrightcylinder: '',
      queue: [],
      order: ['prescriptionType', 'lensType', 'tintType', 'tintColor', 'lightAdjustingType', 'provideOption', 'odrightsphere', 'osleftsphere', 'osleftcylinder', 'odrightcylinder'],
    },

    methods: {
      clear: function (start) {
        var index = this.order.indexOf(start) + 1;
        for (var i = index; i < this.order.length; i++) {
          this[this.order[i]] = '';
        }
      },
      handleThicknessChange: function (event) {
        event.preventDefault();
        event.stopPropagation();
        var vm = this;
        var value = event.currentTarget.value;
        var thicknessIdValue = {
          29921529987171: 1.50, 
          29921529823331: 1.56,
          29921529856099: 1.59, 
          29921529888867: 1.60, 
          29921529921635: 1.67, 
          29921529954403: 1.74, 
        }

        // 1.50 (standard) and 1.56 options can go up to -5.00
        // Polycarbonate and 1,6 can go up to -7,00
        if ((vm.osleftsphere && vm.osleftsphere >= -5 || vm.odrightsphere && vm.odrightsphere >= -5) 
          && (vm.osleftsphere && vm.osleftsphere < 4 || vm.odrightsphere && vm.odrightsphere < 4) 
          && !vm.thickness) {
          vm.thickness = "29921529987171";
        } else
        // Starting +4,00 has to be automatically upgraded to polycarbonate option and include upgrade options of 1,6 or 1,67. 1.50 an 1.56 not available above +4.00.
        if ((vm.osleftsphere && vm.osleftsphere >= 4 || vm.odrightsphere && vm.odrightsphere >= 4) 
          && (!vm.thickness || thicknessIdValue[value] < "1.59")) {
          vm.thickness = "29921529856099";
        } else
        if ((vm.osleftsphere && vm.osleftsphere < -5 || vm.odrightsphere && vm.odrightsphere < -5) 
          && (vm.osleftsphere && vm.osleftsphere > -7 || vm.odrightsphere && vm.odrightsphere > -7) 
          && (!vm.thickness || thicknessIdValue[value] < "1.60")) {
          if (vm.prescriptionType == "29921530282083") {
            vm.thickness = "29921529856099";
            alert('Lens Thickness changed to 1.59 POLYCARBONATE');
          } else {
            vm.thickness = "29921529888867";
            alert('Lens Thickness changed to 1.60 (HIGH-INDEX POLYMER) THIN');
          }
        } else
        // From -7,00 to -11,00 customer must choose 1,67 upgraded lens option
        if ((vm.osleftsphere && vm.osleftsphere <= -7 || vm.odrightsphere && vm.odrightsphere <= -7) 
          && (!vm.thickness || thicknessIdValue[value] < "1.67")) {
          vm.thickness = "29921529921635";
        } else {
          vm.thickness = value;
        }
      },
      handleSphereChange: function (event) {
        var vm = this;
        var thicknessIdValue = {
          29921529987171: 1.50, 
          29921529823331: 1.56,
          29921529856099: 1.59, 
          29921529888867: 1.60, 
          29921529921635: 1.67, 
          29921529954403: 1.74, 
        }

        // 1.50 (standard) and 1.56 options can go up to -5.00
        // Polycarbonate and 1,6 can go up to -7,00
        if (event.currentTarget.value >= -5 && event.currentTarget.value < 4 && !vm.thickness) {
          vm.thickness = "29921529987171";
          alert('Lens Thickness changed to 1.50 (CR-39 PLASTIC) THICKEST');
        } else 
        // Starting +4,00 has to be automatically upgraded to polycarbonate option and include upgrade options of 1,6 or 1,67. 1.50 an 1.56 not available above +4.00.
        if (event.currentTarget.value >= 4 && (!vm.thickness || thicknessIdValue[vm.thickness] < "1.59")) {
          vm.thickness = "29921529856099";
          alert('Lens Thickness changed to 1.59 POLYCARBONATE');
        } else 
        // -5 -7 available poly and 1.60 and higher is 1.67.
        if (event.currentTarget.value < -5 && event.currentTarget.value > -7 && (!vm.thickness || thicknessIdValue[vm.thickness] < "1.60")) {
          if (vm.prescriptionType == "29921530282083") {
            vm.thickness = "29921529856099";
            alert('Lens Thickness changed to 1.59 POLYCARBONATE');
          } else {
            vm.thickness = "29921529888867";
            alert('Lens Thickness changed to 1.60 (HIGH-INDEX POLYMER) THIN');
          }
        } else 
        // From -7,00 to -11,00 customer must choose 1,67 upgraded lens option
        if (event.currentTarget.value <= -7 && (!vm.thickness || thicknessIdValue[vm.thickness] < "1.67")) {
          if (vm.prescriptionType == "29921530282083") {
            vm.thickness = "29921529856099";
            alert('Lens Thickness changed to 1.59 POLYCARBONATE');
          } else {
            vm.thickness = "29921529921635";
            alert('Lens Thickness changed to 1.67 (HIGH-INDEX POLYMER) THINNER');
          }
        }
      },
      handleSubmit: function (event) {
        event.preventDefault();
        event.stopPropagation();
        var vm = this;

        var quantity = document.querySelector('#quantity').value || 1;
        var productVariantId = document.querySelector('[name="id"]').value;
        // var properties = document.querySelectorAll('[name^="properties"]');

        var moveQueueAlong = function () {
          if (vm.queue.length) {
            var request = vm.queue.shift();
            jQuery.post('/cart/add.js', request, moveQueueAlong);
          } else {
            
            var whatToChange = vm.$refs.productForm.querySelectorAll('[name^="properties"]');

            [...whatToChange].forEach(input => {
              if (idTitleObject[input.value]) {
                input.value = idTitleObject[input.value];
              }
            })

            vm.$refs.productForm.submit();
          }
        };

        // Prescription type
        // Please review it here: https://express-glasses.myshopify.com/admin/products/4019403653219
        // there are !variants! id
        // if (this.prescriptionType == 'single-vision') {
        //   this.queue.push({
        //     quantity: quantity,
        //     id: 29363310067765
        //   })
        // }
        if (this.prescriptionType) {
          this.queue.push({
            quantity: quantity,
            id: this.prescriptionType,
            properties: {
              'hidden': 'hidden',
              'Prescription type': idTitleObject[this.prescriptionType],
              'relatedProduct': productVariantId,
            },
          })
        }
        
        // Lenses Type
        // https://express-glasses.myshopify.com/admin/products/4346083377251/variants/31268405706851
        if (this.lensesType) {
          this.queue.push({
            quantity: quantity,
            id: this.lensesType,
            properties: {
              'hidden': 'hidden',
              'Lenses type': idTitleObject[this.lensesType],
              'relatedProduct': productVariantId,
            },
          });
        }

        // Lens type
        // https://express-glasses.myshopify.com/admin/products/4346083410019/variants/31268405772387
        if (this.lensType) {
          this.queue.push({
            quantity: quantity,
            id: this.lensType,
            properties: {
              'hidden': 'hidden',
              'Lens type': idTitleObject[this.lensType],
              'relatedProduct': productVariantId,
            },
          });
        }

        // Tint type
        // https://express-glasses.myshopify.com/admin/products/4019403554915/variants/29921530118243
        if (this.tintType) {
          this.queue.push({
            quantity: quantity,
            id: this.tintType,
            properties: {
              'hidden': 'hidden',
              'Tint type': idTitleObject[this.tintType],
              'relatedProduct': productVariantId,
            },
          })
        }

        // Light adjusting type
        // https://express-glasses.myshopify.com/admin/products/4019403685987
        if (this.lightAdjustingType) {
          this.queue.push({
            quantity: quantity,
            id: this.lightAdjustingType,
            properties: {
              'hidden': 'hidden',
              'Light adjusting': idTitleObject[this.lightAdjustingType],
              'relatedProduct': productVariantId,
            },
          });
        }
        
        // Lens thickness
        // https://express-glasses.myshopify.com/admin/products/4019403489379
        if (this.thickness) {
          this.queue.push({
            quantity: quantity,
            id: this.thickness,
            properties: {
              'hidden': 'hidden',
              'Lens thickness': idTitleObject[this.thickness],
              'relatedProduct': productVariantId,
            },
          });
        }

        moveQueueAlong();
      },
    }
  });
}
$(document).ready(function(){
  $(".tooltip").tooltip();
})